<template>
  <CustomPage title="品牌关注">
    <div slot="content" style="height: 100%; background-color: #f7f7f7">
      <div
        class="px-3 py-1"
        v-for="(item, index) in brandList"
        :key="item.signBrandId"
      >
        <div
          class="
            flex
            p-2
            justify-between
            items-center
            lightshadow
            rounded-md
            bg-white
          "
        >
          <Collapse class="w-full" v-model="activeNames">
            <CollapseItem :name="index">
              <template #title>
                <div class="flex justify-between items-center p-2">
                  <div style="width: 38px; height: 38px" class="mr-2">
                    <img
                      class="w-full h-full rounded-full lightshadow"
                      :src="item.brandLogo"
                      alt=""
                    />
                  </div>
                  <div class="flex-grow">
                    <div class="font-semibold text-xs">
                      {{ item.brandName }}
                    </div>
                    <div class="text-white flex">
                      <div
                        class="rounded-full px-2 h-5 leading-5 text-xxs mr-1"
                        style="background: #f7b500"
                      >
                        <span>预告活动</span
                        ><span class="text-xs font-semibold">
                          {{ item.warmingUpBrandList.length }}</span
                        >
                      </div>
                      <div
                        class="rounded-full px-2 h-5 leading-5 text-xxs"
                        style="background: #e82035"
                      >
                        <span>开始活动</span
                        ><span class="text-xs font-semibold">
                          {{ item.inProgressBrandList.length }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div
                v-for="iii in item.inProgressBrandList"
                :key="iii.signBrandId"
                class="flex items-center"
                @click="
                  $router.push({
                    name: 'BrandPlace',
                    params: { partId: iii.partId },
                    query: {
                      actId: iii.actId,
                      signBrandId: iii.signBrandId,
                      brandLogo: iii.brandLogo,
                    },
                  })
                "
              >
                <div class="rounded-full w-2 h-2 bg-red mr-1"></div>
                <span>{{ iii.actName + "-" + iii.brandName }}</span>
              </div>
              <div
                v-for="jjj in item.warmingUpBrandList"
                :key="jjj.signBrandId"
                class="flex items-center"
                @click="
                  $router.push({
                    name: 'BrandPlace',
                    params: { partId: jjj.partId },
                    query: {
                      actId: jjj.actId,
                      signBrandId: jjj.signBrandId,
                      brandLogo: jjj.brandLogo,
                    },
                  })
                "
              >
                <div
                  class="rounded-full w-2 h-2 mr-1"
                  style="background: #f7b500"
                ></div>
                <span>{{ jjj.actName + "-" + jjj.brandName }}</span>
              </div>
            </CollapseItem>
          </Collapse>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Icon, Collapse, CollapseItem } from "vant";
import { getFollowingBrands } from "./webApi";
export default {
  components: { CustomPage, Collapse, CollapseItem },
  created() {
    getFollowingBrands().then(({ data }) => {
      this.brandList = data;
    });
  },
  data() {
    return {
      brandList: [],
      activeNames: [0],
    };
  },
};
</script>
<style scoped>
</style>